import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Events, scroller, scrollSpy } from "react-scroll";

import HeroSection from "@/components/HeroSection";
import MarqueeSection from "@/components/MarqueeSection";
import ProductsSection from "@/components/ProductsSection";
import CapabilitiesSection from "@/components/CapabilitiesSection";
import AIFeatureSection from "@/components/AIFeatureSection";
import AboutUsSection from "@/components/AboutUsSection";
import PortfolioSection from "@/components/PortfolioSection";
import SocialProofSection from "@/components/SocialProofSection";
import PackagesSection from "@/components/PackagesSection";
import EstimatorSection from "@/components/EstimatorSection";
import CTABandSection from "@/components/CTABandSection";
import ContactSection from "@/components/ContactSection";

const LandingPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    Events.scrollEvent.register("begin", function () {});
    Events.scrollEvent.register("end", function () {});
    scrollSpy.update();
    return () => {
      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
    };
  }, []);

  // Honor URL hash on mount — e.g. /#contact-section from off-landing links
  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (!hash) return;
    // Small delay so sections are rendered and scrollSpy is ready
    const id = setTimeout(() => {
      scroller.scrollTo(hash, { duration: 500, smooth: true, offset: -80 });
    }, 100);
    return () => clearTimeout(id);
  }, [location.hash]);

  return (
    <main>
      <HeroSection />
      <MarqueeSection />
      <ProductsSection />
      <CapabilitiesSection />
      <AIFeatureSection />
      <AboutUsSection />
      <PortfolioSection />
      <SocialProofSection />
      <PackagesSection />
      <EstimatorSection />
      <CTABandSection />
      <ContactSection />
    </main>
  );
};

export default LandingPage;
